module.exports = __webpack_public_path__ + "img/Oil_tank_card.0b8c1053.png";